var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateLeftIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 75,
    viewBox: "0 0 77 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.2891 5.67542L57.2891 -7.97946L41.3584 -7.97946L41.3584 -23.9102L27.7036 -23.9102L27.7036 -7.97946L11.7729 -7.97946L11.7729 5.67542L27.7036 5.67542L27.7036 21.6061L41.3584 21.6061L41.3584 5.67542L57.2891 5.67542Z",
    fill: "#F6FAFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.7109 50.1896V40.499H65.4053V29.1934L55.7148 29.1934V40.499H44.4092V50.1896H55.7148V61.4952H65.4053V50.1896H76.7109ZM63.7217 42.1826V30.877L54.0312 30.877V42.1826H42.7255V51.8732H54.0312V63.1788H63.7217V51.8732H75.0273V42.1826H63.7217ZM74.4204 42.7895H63.1148V31.4838L54.638 31.4838V42.7895H43.3324V51.2663H54.638V62.572H63.1148V51.2663H74.4204V42.7895Z",
    fill: "#A6C6F9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0562 54.2204L20.8917 65.056L12.0946 73.8532L1.25903 63.0176L0.829893 62.5885L0.400763 63.0176L-10.4348 73.8532L-19.232 65.056L-8.39641 54.2204L-7.96728 53.7913L-8.39641 53.3621L-19.232 42.5266L-10.4348 33.7294L0.400763 44.5649L0.829893 44.9941L1.25903 44.5649L12.0946 33.7294L20.8917 42.5266L10.0562 53.3621L9.62707 53.7913L10.0562 54.2204Z",
    stroke: "#A6C6F9",
    strokeWidth: 1.21377
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateLeftIcon);
export default __webpack_public_path__ + "static/media/create-left-icon.d413d8e968c9ce379ef9b0f3e8c14a03.svg";
export { ForwardRef as ReactComponent };